// extracted by mini-css-extract-plugin
export default {"btn":"CopyButton_btn__XfqS0","icon":"CopyButton_icon__xMnQ7","caption":"CopyButton_caption__wmXd5"};